import { lazy, Suspense, FC } from "react";
import Loader from "../../components/Loader/Loader";

const AdminPageLayout = lazy(() => import("./AdminPageLayout"));

const AdminPageLayoutLazy: FC = () => (
  <Suspense fallback={<Loader loader="https://lottie.host/1b67ed33-71e6-451c-a8f4-8a2a8a044214/laSvZ6MweM.json" imageSrc="" isImage={false} />}>
    <AdminPageLayout />
  </Suspense>
);

export default AdminPageLayoutLazy;
